import { useContext } from 'react';

import { AnnotationsActionsContext } from '../contexts/AnnotationsActionsContext.js';

export const useAnnotationsActions = () =>
  useContext(AnnotationsActionsContext);
